export const AUTHROIZATION_FETCH_URL_PREFIX = '';

export const PREFIX_HOST =
  typeof window !== 'undefined' && window.location && window.location.origin
    ? window.location.origin
    : '';

// 上传文件至服务器
export const COMMON_FILE_UPLOAD = AUTHROIZATION_FETCH_URL_PREFIX + '/TrendyScm-rest/rest/common/file/upload';
// OSS上传/下载
export const COMMON_PIC_UPLOAD_OSS_BYTOKEN = AUTHROIZATION_FETCH_URL_PREFIX + '/app-lscm/sys/oss/pic/uploadByToken'; // 外网上传图片
export const COMMON_FILE_UPLOAD_OSS_BYTOKEN = AUTHROIZATION_FETCH_URL_PREFIX + '/app-lscm/sys/oss/file/uploadByToken'; 
export const COMMON_FILE_UPLOAD_OSS = AUTHROIZATION_FETCH_URL_PREFIX + '/app-lscm/sys/oss/file/upload'; 
export const COMMON_PIC_UPLOAD_OSS = AUTHROIZATION_FETCH_URL_PREFIX + '/app-lscm/sys/oss/pic/upload'; 
export const COMMON_FILE_OSS_SHOW_PIC_BYTOKEN = AUTHROIZATION_FETCH_URL_PREFIX + '/app-lscm/sys/oss/pic/showByToken';
export const COMMON_FILE_OSS_SHOW_PIC = AUTHROIZATION_FETCH_URL_PREFIX + '/app-lscm/sys/oss/pic/show';
export const COMMON_FILE_OSS_DOWNLOAD = AUTHROIZATION_FETCH_URL_PREFIX + '/app-lscm/sys/oss/file/downLoad';
export const QC_SCHELING_CHECKLIST_EXPORT = AUTHROIZATION_FETCH_URL_PREFIX + '/app-lscm/qcScheling/checkList/export';


// 吊牌导入中文
export const POST_TAG_INFO_IMPORT_CN_TAG = AUTHROIZATION_FETCH_URL_PREFIX + '/app-lscm/tagInfo/importCnTag';
//吊牌导入英文
export const  POST_TAG_INFO_IMPORT_EN_TAG= AUTHROIZATION_FETCH_URL_PREFIX + '/app-lscm/tagInfo/importEnTag';

// export const TECH_MATERIAL_IMPORT = AUTHROIZATION_FETCH_URL_PREFIX + '/TrendyScm-rest/rest/tech/material/import'
// 洗水唛
export const POST_IMPORT_WASHLABEL = AUTHROIZATION_FETCH_URL_PREFIX + '/app-lscm/washLabel/import'

// 预制发票
export const POST_INVOICE_ALLOCATE_SAVE_IMPORT = AUTHROIZATION_FETCH_URL_PREFIX + '/app-lscm/invoice/allocate/save/import'

export const POST_TRENDMATERIALATTRS_IMPORTFILE = AUTHROIZATION_FETCH_URL_PREFIX + '/TrendyScm-rest/rest/MasterData/TrendMaterialAttrs/importFile'
